import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

let scriptPromise = null;
function loadJitsiScript() {
  if (window.JitsiMeetExternalAPI) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://meet.jit.si/external_api.js";
    s.async = true;
    s.onload = resolve;
    s.onerror = reject;
    document.body.appendChild(s);
  });
  return scriptPromise;
}

// room: string room name; height: css height
export default function JitsiRoom({ room, height = "70vh" }) {
  const { user } = useAuth();
  const ref = useRef(null);
  const apiRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let disposed = false;
    loadJitsiScript().then(() => {
      if (disposed || !ref.current) return;
      apiRef.current = new window.JitsiMeetExternalAPI("meet.jit.si", {
        roomName: room,
        parentNode: ref.current,
        userInfo: { displayName: user?.name || "TitleHub User" },
        configOverwrite: { prejoinPageEnabled: false, disableDeepLinking: true },
        interfaceConfigOverwrite: { MOBILE_APP_PROMO: false },
      });
      apiRef.current.addListener("videoConferenceJoined", () => setLoading(false));
      setTimeout(() => setLoading(false), 4000);
    }).catch(() => setLoading(false));
    return () => {
      disposed = true;
      try { apiRef.current?.dispose(); } catch {}
    };
    // eslint-disable-next-line
  }, [room]);

  return (
    <div className="relative rounded-lg overflow-hidden border border-border bg-slate-900" style={{ height }} data-testid="jitsi-room">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center text-white/80 gap-2 z-10">
          <Loader2 className="h-5 w-5 animate-spin" /> Connecting to the room…
        </div>
      )}
      <div ref={ref} className="h-full w-full" />
    </div>
  );
}
